<template>
	<div class="pa-6">
		<v-card-title class="pa-0 mb-3">
			{{ $vuetify.lang.t("$vuetify.views.tasks.stats.header") }}
		</v-card-title>
		<div class="d-flex justify-space-between stats-container py-4">
			<span class="stat-name ">
				{{ $vuetify.lang.t("$vuetify.views.tasks.stats.allTasks") }}
			</span>
			<span class="stat-number ">
				{{ stats.allTasks }}
			</span>
		</div>

		<div class="d-flex justify-space-between stats-container py-4">
			<span class="stat-name ">
				{{
					$vuetify.lang.t("$vuetify.views.tasks.stats.completedTasks")
				}}
			</span>
			<span class="stat-number "
				>{{ stats.finishedTasks }}
			</span>
		</div>

		<div class="d-flex justify-space-between stats-container py-4">
			<span class="stat-name text-subtitle-1">
				{{ $vuetify.lang.t("$vuetify.views.tasks.stats.createdLists") }}
			</span>
			<span class="stat-number "
				>{{ stats.taskLists }}
			</span>
		</div>

		<div class="d-flex justify-space-between stats-container py-4">
			<span class="stat-name text-subtitle-1">
				{{ $vuetify.lang.t("$vuetify.views.tasks.stats.addedTags") }}
			</span>
			<span class="stat-number text-subtitle-1">{{ stats.tags }}</span>
		</div>
	</div>
</template>

<script>
import axios from "axios";

export default {
	data() {
		return {
			stats: {},
		};
	},
	async created() {
		await axios
			.get("tasks/stats/data")
			.then((response) => {
				this.stats = response.data.data;
			})
			.catch((error) => {
				console.log("GET TASK STATS ERROR", error);
			});
	},
};
</script>

<style lang="scss" scoped>
.stats-container {
	border-bottom: 1px solid var(--v-grey-lighten2);
}

.stat-number,
.stat-name {
	font-weight: 500 !important;
}

.stat-name {
	color: var(--v-grey-base);
}

.stat-number {
	color: var(--v-grey-darken1);
}
</style>
